import About from 'components/about/AboutUs';
import AccountSignup from 'components/account/AccountSignup';
import LessonProvider from 'components/main/LessonsProvider';
import Search from 'components/search/Search';
import SubmitLanding from 'components/submit/SubmitLanding';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import NotFound from '../NotFound';
import styles from './AppContent.module.css';

const AppContent: React.FC = () => {
  return (
    <div className={styles.content}>
      <div className={styles.container}>
        <LessonProvider>
          <Switch>
            <Route path="/" exact component={Search} />
            <Route path="/submit" component={SubmitLanding} />
            <Route path="/about" component={About} />
            <Route path="/signup" component={AccountSignup} />
            <Route component={NotFound} />
          </Switch>
        </LessonProvider>
      </div>
    </div>
  );
};

export default AppContent;
